// extracted by mini-css-extract-plugin
export default {"group":"styles_group__tWuIt","label":"styles_label__uDuw3"};